import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
const _excluded = ["entityGroups", "parent"];
import React from 'react';
import PropTypes from 'prop-types';
import { useGetEntitySchemasAsObj } from '@blaze-cms/react-page-builder';
import { buildShapesConfig } from './helpers';
import GoogleMapsRender from './GoogleMapsRender';
import GoogleMapsHtml from './GoogleMapsHtml';
const GoogleMapsFactory = _ref => {
  let {
      entityGroups,
      parent
    } = _ref,
    otherProps = _objectWithoutProperties(_ref, _excluded);
  const {
    data,
    loading,
    error
  } = useGetEntitySchemasAsObj(entityGroups.map(({
    entity
  }) => entity));
  if (loading) return /*#__PURE__*/React.createElement(GoogleMapsHtml, null);
  if (error) return error.message;
  const shapeConfigs = buildShapesConfig(data, entityGroups, parent);
  return /*#__PURE__*/React.createElement(GoogleMapsRender, _extends({
    shapeConfigs: shapeConfigs,
    entityGroups: entityGroups,
    parent: parent
  }, otherProps));
};
GoogleMapsFactory.propTypes = {
  parent: PropTypes.object,
  entityGroups: PropTypes.array
};
GoogleMapsFactory.defaultProps = {
  parent: {},
  entityGroups: []
};
export default GoogleMapsFactory;
//# sourceMappingURL=GoogleMapsFactory.js.map